<template>
  <div class="button-options-setting-active-and-hover">
    <el-collapse v-model="activeNames" style="width: 100%">
      <div class="subBackBox" @click="closePopover">
        <i class="subBackIcon icon-portal-arrows-left"></i>
        <span class="subBackTitle">弹出框</span>
      </div>
      <el-collapse-item title="位置" name="1">
        <div class="content-item verticallyBetweenCenter">
          <span class="verticallyCenter">位置</span>
          <el-select v-model="popoverPositonType" style="width: 176px">
            <el-option v-for="(item, index) in positonOptions" :key="index" :label="item.label" :value="item.value">
              <span style="font-size: 13px">{{ item.label }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="content-item verticallyBetweenCenter mt8">
          <span class="verticallyCenter">左右偏移</span>
          <slider-and-input
            :value.sync="spacingH"
            :sliderMin="-1000"
            :sliderMax="1000"
            suffix="px"
            inputWidth="small"
            inputHeight="small"
            style="width: 166px"
          />
        </div>
        <div class="content-item verticallyBetweenCenter mt8">
          <span class="verticallyCenter">上下偏移</span>
          <slider-and-input
            :value.sync="spacing"
            :sliderMin="-1000"
            :sliderMax="1000"
            suffix="px"
            inputWidth="small"
            inputHeight="small"
            style="width: 166px"
          />
        </div>
      </el-collapse-item>
      <widthAndHeightSize
        :widthVal.sync="width"
        :heightVal.sync="height"
        :widthAuto="false"
        :heightAuto="false"
        :disableWidthAuto="true"
        :disableHeightAuto="true"
      />
      <el-collapse-item title="排列" name="3" v-if="showRowColLayout && !isWaterFall">
        <rowColLayoutSetting :options="popoverLayoutParams" :ids="ids" @update="handleSet" />
      </el-collapse-item>
      <el-collapse-item title="背景" name="3">
        <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" :options="popoverParams" />
      </el-collapse-item>
      <el-collapse-item title="边框" name="4">
        <div>
          <div class="content-item verticallyCenter mb8">
            <el-checkbox v-model="showBorder">显示边框</el-checkbox>
          </div>
          <cx-border
            v-if="showBorder"
            :borderWidth.sync="borderWidth"
            :borderStyle.sync="borderStyle"
            :borderColor.sync="borderColor"
            :borderIsThemeColor.sync="borderIsThemeColor"
          />
        </div>
        <div class="content-item mt16">
          <border-radius
            :borderTypeFlag.sync="borderTypeFlag"
            :borderRadius.sync="borderRadius"
            :borderTopLeftRadius.sync="borderTopLeftRadius"
            :borderTopRightRadius.sync="borderTopRightRadius"
            :borderBottomRightRadius.sync="borderBottomRightRadius"
            :borderBottomLeftRadius.sync="borderBottomLeftRadius"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item title="边距" name="5">
        <div class="setting-item">
          <div class="content">
            <div class="content-item">
              <cx-padding
                :paddingTypeFlag.sync="paddingTypeFlag"
                :padding.sync="padding"
                :paddingTop.sync="paddingTop"
                :paddingRight.sync="paddingRight"
                :paddingBottom.sync="paddingBottom"
                :paddingLeft.sync="paddingLeft"
              />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="更多" name="6">
        <div class="setting-item">
          <div class="content">
            <div class="content-item mb16">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <cx-slider
              label="触发方式"
              :value.sync="triggerType"
              :options="[
                { title: '悬浮', value: 'hover' },
                { title: '点击', value: 'click' }
              ]"
              :showToolTip="false"
            />
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
            <div class="content-item verticallyBetweenCenter mt12" v-if="!waterFlow">
              <span class="verticallyCenter">
                布局模式<i class="tips-btn icon-portal-info2" @click="explainDialog = true"></i>
              </span>
              <el-select v-model="autoLayoutType" style="width: 120px">
                <el-option v-for="(item, index) in layoutTypeList" :key="index" :label="item.label" :value="item.value">
                  <span style="font-size: 13px">{{ item.label }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="content-item verticallyCenter mt12" v-show="showRowColLayout">
              <span class="mr16">溢出</span>
              <text-setting-overflow :overFlowType.sync="overFlowType" style="flex: 1"></text-setting-overflow>
            </div>
            <div class="data-item mt12">
              <el-checkbox v-model="showClose">显示“关闭按钮”</el-checkbox>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <div class="auto-layout-body">
        <p class="fs14 tips">
          <span>排列模式：</span>
        </p>
        <ul>
          <li>开启排列模式后，布局内部元素会按照一定方向排列，配合行布局组件可以实现均匀的排列效果</li>
        </ul>
        <p class="fs14 tips">
          <span>功能说明：</span>
        </p>
        <p>
          通常情况下，一个网页的元素是遵从一定的顺序进行排列，例如2张图片横向排列，第3张以及后续图片都希望自动往左侧填充，超过宽度则自动换行，不仅可以减少整理页面的时间还可以实现更灵活的自适应效果。可以理解「自动布局」是为了简化原生页面使用Flex属性，并且达到类似的效果，你可以做到：
        </p>
        <ul>
          <li>让按钮或卡片随文本增减而自动调整尺寸</li>
          <li>将列表快速重新排序</li>
          <li>实现更多更复杂元素的全自动排布</li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import widthAndHeightSize from "publicSetting/widthAndHeightSize"
import textSettingOverflow from "modules/components/textSettingOverflow"
import rowColLayoutSetting from "../../../autoLayout/toolbars/setting/rowColLayoutSetting.vue"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "button-active-and-hover",
  components: { widthAndHeightSize, textSettingOverflow, rowColLayoutSetting },
  props: {
    options: Object
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      sliderMax: 360,
      positonOptions: [
        {
          label: "上方左对齐",
          value: "top-start"
        },
        {
          label: "上方居中对齐",
          value: "top"
        },
        {
          label: "上方右对齐",
          value: "top-end"
        },
        {
          label: "下方左对齐",
          value: "bottom-start"
        },
        {
          label: "下方居中对齐",
          value: "bottom"
        },
        {
          label: "下方右对齐",
          value: "bottom-end"
        },
        {
          label: "左侧顶对齐",
          value: "left-start"
        },
        {
          label: "左侧居中对齐",
          value: "left"
        },
        {
          label: "左侧底对齐",
          value: "left-end"
        },
        {
          label: "右侧顶对齐",
          value: "right-start"
        },
        {
          label: "右侧居中对齐",
          value: "right"
        },
        {
          label: "右侧底对齐",
          value: "right-end"
        }
      ],
      explainDialog: false,
      layoutTypeList: [
        {
          label: "自由拖拽",
          value: "free"
        },
        {
          label: "纵向排列",
          value: "vertical"
        },
        {
          label: "横向排列",
          value: "horizon"
        }
      ]
    }
  },
  computed: {
    popoverIds() {
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const index = pageLayoutList.findIndex(item => item.options.source_id === this.options.popoverPath)
      return {
        container_id: 0,
        pageLayoutId: index
      }
    },
    popoverLayoutIds() {
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const index = pageLayoutList.findIndex(item => item.options.source_id === this.options.popoverPath)
      return {
        container_id: 0,
        pageLayoutId: `${index}_0`
      }
    },
    popoverParams() {
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const popoverLayout = pageLayoutList.find(item => item.options.source_id === this.options.popoverPath)
      return popoverLayout.options.popoverParams
    },
    popoverLayoutParams() {
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const popoverLayout = pageLayoutList.find(item => item.options.source_id === this.options.popoverPath)
      return popoverLayout.layout.rows[0].options
    },
    layout() {
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const popoverLayout = pageLayoutList.find(item => item.options.source_id === this.options.popoverPath)
      return popoverLayout.layout.rows[0]
    },
    ids() {
      return this.$store.state.states.activeID
    },
    isWaterFall() {
      return this.$store.state[this.request_prefix].page.isWaterFall === "waterFall" ? true : false
    },
    popoverPositonType: {
      get() {
        return this.popoverParams.popoverPositonType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "popoverParams.popoverPositonType", false, false, this.popoverIds)
      }
    },
    spacing: {
      get() {
        return this.popoverParams.spacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "popoverParams.spacing", false, false, this.popoverIds)
      }
    },
    spacingH: {
      get() {
        return this.popoverParams.spacingH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "popoverParams.spacingH", false, false, this.popoverIds)
      }
    },
    width: {
      get() {
        return this.popoverParams.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "popoverParams.width", false, false, this.popoverIds)
      }
    },
    height: {
      get() {
        return this.popoverParams.height
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "popoverParams.height", false, false, this.popoverIds)
        this.$changeOptionsEV(newVal, "height", false, false, this.popoverLayoutIds, true)
      }
    },
    triggerType: {
      get() {
        return this.popoverParams.triggerType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "popoverParams.triggerType", false, false, this.popoverIds)
      }
    },
    showClose: {
      get() {
        return this.popoverParams.showClose
      },
      set(newVal) {
        this.layout.rectIds.forEach(it => {
          // 找到关闭图标组件
          this.$store.state[this.request_prefix].page.children[0].children.forEach(item => {
            if (item.rect_id === it && item.options.pluginName.includes("controlPopoverPlugin")) {
              this.$changeOptionsEV(newVal, "isShow", null, false, {
                rect_id: it,
                container_id: 0
              })
            }
          })
        })
        this.$changeOptionsEV(newVal, "popoverParams.showClose", false, false, this.popoverIds)
      }
    },
    background: {
      get() {
        let background = this.popoverLayoutParams.bg
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: "rgba(255, 255, 255, 1)"
          }
        ]
        this.$changeOptionsEV(newBackground, "bg", false, false, this.popoverLayoutIds, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bg", false, false, this.popoverLayoutIds)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.popoverLayoutParams.borderRadius[0]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderRadius.0", false, false, this.popoverLayoutIds)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.popoverLayoutParams.borderRadius[1]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderRadius.1", false, false, this.popoverLayoutIds)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.popoverLayoutParams.borderRadius[2]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderRadius.2", false, false, this.popoverLayoutIds)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.popoverLayoutParams.borderRadius[3]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderRadius.3", false, false, this.popoverLayoutIds)
      }
    },
    borderRadius: {
      get() {
        return this.popoverLayoutParams.borderRadius[0]
      },
      set(newVal) {
        this.$changeOptionsEV([newVal, newVal, newVal, newVal], "borderRadius", false, false, this.popoverLayoutIds)
      }
    },
    borderStyle: {
      get() {
        return this.popoverLayoutParams.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false, false, this.popoverLayoutIds)
      }
    },
    borderColor: {
      get() {
        return this.popoverLayoutParams.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false, false, this.popoverLayoutIds)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.popoverLayoutParams.hasOwnProperty("borderTypeFlag")) {
          if (((this.borderRadius[0] === this.borderRadius[1]) === this.borderRadius[2]) === this.borderRadius[3]) {
            defaultType = 2
          }
        }
        return this.popoverLayoutParams.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false, false, this.popoverLayoutIds)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.popoverLayoutParams.showBorder === undefined) {
          if (this.popoverLayoutParams.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.popoverLayoutParams.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false, false, this.popoverLayoutIds)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false, false, this.popoverLayoutIds)
        }
      }
    },
    borderWidth: {
      get() {
        return this.popoverLayoutParams.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false, false, this.popoverLayoutIds)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.popoverLayoutParams.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false, false, this.popoverLayoutIds)
      }
    },
    paddingTypeFlag: {
      get() {
        return this.popoverLayoutParams.paddingTypeFlag
      },
      set(newVal) {
        if (newVal === 1) {
          this.$changeOptionsEV(
            [[this.paddingTop, this.paddingTop, this.paddingTop, this.paddingTop], newVal],
            ["padding", "paddingTypeFlag"],
            false,
            false,
            this.popoverLayoutIds
          )
        } else {
          this.$changeOptionsEV(newVal, "paddingTypeFlag", false, false, this.popoverLayoutIds)
        }
      }
    },
    padding: {
      get() {
        return this.popoverLayoutParams.padding[0]
      },
      set(newVal) {
        this.$changeOptionsEV([newVal, newVal, newVal, newVal], "padding", false, false, this.popoverLayoutIds)
      }
    },
    paddingTop: {
      get() {
        return this.popoverLayoutParams.padding[0]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding.0", false, false, this.popoverLayoutIds)
      }
    },
    paddingRight: {
      get() {
        return this.popoverLayoutParams.padding[1]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding.1", false, false, this.popoverLayoutIds)
      }
    },
    paddingBottom: {
      get() {
        return this.popoverLayoutParams.padding[2]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding.2", false, false, this.popoverLayoutIds)
      }
    },
    paddingLeft: {
      get() {
        return this.popoverLayoutParams.padding[3]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding.3", false, false, this.popoverLayoutIds)
      }
    },
    opacity: {
      get() {
        return this.popoverLayoutParams.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false, false, this.popoverLayoutIds)
      }
    },
    boxShadowColor: {
      get() {
        return this.popoverLayoutParams.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false, false, this.popoverLayoutIds)
      }
    },
    boxShadowH: {
      get() {
        return this.popoverLayoutParams.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false, false, this.popoverLayoutIds)
      }
    },
    boxShadowV: {
      get() {
        return this.popoverLayoutParams.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false, false, this.popoverLayoutIds)
      }
    },
    boxShadowBlur: {
      get() {
        return this.popoverLayoutParams.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false, false, this.popoverLayoutIds)
      }
    },
    boxShadowSpread: {
      get() {
        return this.popoverLayoutParams.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false, false, this.popoverLayoutIds)
      }
    },
    waterFlow: {
      get() {
        return this.popoverLayoutParams.hasOwnProperty("waterFlow") ? this.popoverLayoutParams.waterFlow : false
      }
    },
    showRowColLayout: {
      get() {
        return this.popoverLayoutParams.hasOwnProperty("showRowColLayout")
          ? this.popoverLayoutParams.showRowColLayout
          : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showRowColLayout", false, false, this.popoverLayoutIds)
      }
    },
    autoLayoutType: {
      get() {
        if (this.showRowColLayout) {
          return this.popoverLayoutParams.rowColDirection || "vertical"
        } else {
          return "free"
        }
      },
      set(newVal) {
        if (newVal === "free") {
          this.showRowColLayout = false
        } else {
          this.showRowColLayout = true
          this.$changeOptionsEV(newVal, "rowColDirection", false, false, this.popoverLayoutIds)
        }
      }
    },
    heightType: {
      get() {
        return this.popoverLayoutParams.heightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "heightType", false, false, this.popoverLayoutIds)
      }
    },
    overFlowType: {
      get() {
        return this.popoverLayoutParams.hasOwnProperty("overFlowType")
          ? this.popoverLayoutParams.overFlowType
          : "visible"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "overFlowType", false, false, this.popoverLayoutIds)
      }
    }
  },
  methods: {
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0, 0, 0, 0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    changeSubItem(val, flag) {
      this.$emit("changeSubItem", val, flag)
    },
    handleSet(key, val) {
      this.$changeOptionsEV(val, key, false, false, this.popoverLayoutIds)
    },
    closePopover() {
      this.changeSubItem(0, false)
      this.$eventBus.$emit("control-popover", {
        openPopover: false,
        sourceId: this.options.popoverPath
      })
    }
  }
})
</script>

<style scoped>
.paddingl54 {
  padding-left: 54px;
}
</style>
